/** Tipo efetivo do usuário (prioriza objeto `user` sobre localStorage). */
export function resolveUserType(
  storedUserType: string | null | undefined,
  user?: { user_type?: string } | null,
): string | null {
  const fromUser = user?.user_type?.trim();
  if (fromUser) return fromUser;
  const fromStorage = storedUserType?.trim();
  return fromStorage || null;
}

export function isGuestUser(userType: string | null | undefined): boolean {
  return userType === 'guest';
}

export function isOwnerUser(userType: string | null | undefined): boolean {
  return userType === 'owner';
}

/** CTA "Assine Live" / card de assinatura — somente proprietários sem plano Live. */
export function canShowLiveSubscriptionPromo(
  storedUserType: string | null | undefined,
  subscriptionPlan: string | null | undefined,
  user?: { user_type?: string } | null,
): boolean {
  const type = resolveUserType(storedUserType, user);
  if (!isOwnerUser(type) || isGuestUser(type)) return false;
  return subscriptionPlan !== 'live';
}

/** Banner "Plano Live ativo" — somente proprietários com plano Live. */
export function canShowLiveActiveBanner(
  storedUserType: string | null | undefined,
  subscriptionPlan: string | null | undefined,
  user?: { user_type?: string } | null,
): boolean {
  const type = resolveUserType(storedUserType, user);
  if (!isOwnerUser(type) || isGuestUser(type)) return false;
  return subscriptionPlan === 'live';
}
